import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Api from "../api/api";
export default class SharedIsi {
  static getCaptions(stations) {
    var captions = [];
    stations.forEach((station) => {
      if (station.quayCode !== undefined)
        captions.push(station.quayCode.split(":")[2]);
    });
    return captions;
  }

  static downloadTravelInfoPdf = (
    fullCaptionName,
    albumName,
    stationName,
    pdfNotExistMessage
  ) => {
    const caption = fullCaptionName.split(":")[2];
    Api.downloadAsset(caption, albumName, stationName).then((response) => {
      if (response.data.size === 0) {
        toast(pdfNotExistMessage, {
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${stationName}.pdf`;
        link.click();
        link.remove();
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/utils/sharedIsi.js